import React from 'react'
import injectStyles from 'react-jss'
import styles from '../styles'

const QuizQuestionsFormView = ({ children, classes }) => {
  return <div className={classes.wrapper}>{children}</div>
}

export default injectStyles(styles)(QuizQuestionsFormView)
